import { useContext, useLayoutEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import { LoadingContext } from "../../../../../contexts/Loading/LoadingContext";
import { api, errorTreatment } from "../../../../../services/api";
import LoadingGraphics from "../../../../Loading/LoadingGraphics";
import NumberProps from "../NumberProps";
import { AuthContext } from "../../../../../contexts/Authentication/AuthContext";

export const NumbersDayCollectsDocumentsNotStarted = () => {
  const { id, shortToken , mode } = useParams();
  const { changeVisibility } = useContext(LoadingContext);
  const { hasShortToken} = useContext(AuthContext);
  const {
    reloadComponent,
    componentProperty,
    generateRedirectUrl
  } = useContext(DashboardContext);
  const [documents, setDocuments] = useState<{ count: number } | null>(null);
  const [completeRequisition, setCompleteRequisition] = useState(false);

  let routeDocuments: string;

  if (hasShortToken) {
    routeDocuments = `/documents/collects?graphic_id=numbersDayCollectsDocumentsNotStarted&short_token=${shortToken}&screen_id=${id}`;
  } else {
    routeDocuments = `/documents/collects?graphic_id=numbersDayCollectsDocumentsNotStarted&screen_id=${id}`;
  }

  useLayoutEffect(() => {
    changeVisibility(true);
    const fetchData = () => {
      try {
        requisition();
      } finally {
        changeVisibility(false);
      }
    };
    fetchData();
    if (mode === "view") {
      const intervalId = setInterval(() => {
        requisition();
      }, 60000);
      return () => clearInterval(intervalId);
    }
  }, []);

  async function requisition() {
    return await api
      .get(routeDocuments)
      .then((documents: { data: { count: number } }) => {
        if (!documents.data) return;
        loadDataChart(documents.data);
      })
      .catch((error) => {
        errorTreatment(error);
        return 0;
      });
  }

  const loadDataChart = async (doc: { count: number } | null) => {
    if (mode === "view" &&
    componentProperty({
      id: "numbersDayCollectsDocumentsNotStarted",
      property: "redirect",
    })) {
      const number = document.querySelector(
        "#numbers-day-collects-documents-not-started"
      );
      if (number) {
        number.addEventListener("click", async function () {
          window.open(
            await generateRedirectUrl("numbersDayCollectsDocumentsNotStarted", {
              redirectTowerToIndex: true,
              date: true,
              dueRouteDate: true,
              route_stop_type: 'C',
              status_stop_id: '0,7,12,15,20'
            }),
            "_blank"
          );
        });
      }
    }
    setDocuments(doc);
    setCompleteRequisition(true);
  };

  return (
    <div id="numbers-day-collects-documents-not-started" className="w-100">
      {completeRequisition && !reloadComponent && documents ? (
        <NumberProps
          value={documents}
          title="Coletas não Iniciadas"
          id="numbers-day-collects-documents-not-started"
          clickable={componentProperty({
            id: "numbersDayCollectsDocumentsNotStarted",
            property: "redirect",
          })}
          scale={6.5}
        />
      ) : (
        <LoadingGraphics />
      )}
    </div>
  );
};
